'use client';

import { useEffect } from 'react';
import { Spinner } from '@/app/components/Spinner';
import { TOKEN_KEY } from '@/consts/const';
import { clearImpersonatingFlag } from '@/utils/auth/impersonation';
import { getCrmBackToSuperAdminUrl } from '@/utils/crm/crmUrls';
import { isAllowedCrmRedirect } from '@/utils/crm/isAllowedCrmRedirect';

export default function ExitImpersonationRedirect() {
  useEffect(() => {
    localStorage.removeItem(TOKEN_KEY);
    clearImpersonatingFlag();

    const redirect = new URLSearchParams(window.location.search).get('redirect');
    const targetUrl =
      redirect && isAllowedCrmRedirect(redirect) ? redirect : getCrmBackToSuperAdminUrl();

    window.location.replace(targetUrl);
  }, []);

  return <Spinner />;
}
